import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { JwtRequest, JwtResponse } from 'src/app/interfaces/jwt';
import { ResponseModel } from 'src/app/interfaces/response';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    public currentUser: Observable<JwtResponse>;
    private currentUserSubject: BehaviorSubject<JwtResponse>;

    constructor(private httpClient: HttpClient) { 
        this.currentUserSubject = new BehaviorSubject<JwtResponse>(JSON.parse(localStorage.getItem('currentUser') || '{}'));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public setCurrentUserValue(jwtResponse) {
        this.currentUserSubject.next(jwtResponse);
    }
  
    public get currentUserValue(): JwtResponse {
      return this.currentUserSubject.value;
    }

    async acceder(jwtRequest: JwtRequest): Promise<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return await this.httpClient.post<ResponseModel<JwtRequest>>(`${environment.baseApi}/web/login`, jwtRequest, { headers }).toPromise();
    }

    async googleLogin(credential: string, rol: string = 'candidato', loginOnly = false): Promise<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return await this.httpClient.post(`${environment.baseApi}/publico/auth/google?rol=${rol}&loginOnly=${loginOnly}`, { credential }, { headers }).toPromise();
    }

    async linkedinLogin(code: string, rol: string = 'candidato', loginOnly = false): Promise<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return await this.httpClient.post(`${environment.baseApi}/publico/auth/linkedin?rol=${rol}&loginOnly=${loginOnly}`, { code }, { headers }).toPromise();
    }

    async whatsappSendOtp(phone: string): Promise<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return await this.httpClient.post(`${environment.baseApi}/publico/auth/whatsapp/otp/send`, { phone }, { headers }).toPromise();
    }

    async whatsappVerifyOtp(phone: string, code: string): Promise<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return await this.httpClient.post(`${environment.baseApi}/publico/auth/whatsapp/otp/verify`, { phone, code }, { headers }).toPromise();
    }

    async whatsappResolve(phone: string, action: 'LINK' | 'NEW'): Promise<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return await this.httpClient.post(`${environment.baseApi}/publico/auth/whatsapp/otp/resolve`, { phone, action }, { headers }).toPromise();
    }

    cerrarSesion() {
        localStorage.removeItem('currentUser');
        localStorage.removeItem('currentSync');
        localStorage.removeItem('idCurrentSync');
        localStorage.removeItem('statusCurrentSync');
        this.currentUserSubject.next(null);
    }

    /** Decodifica el JWT sin verificar firma y comprueba si expiró */
    isTokenExpired(): boolean {
        const user = this.currentUserSubject.value;
        if (!user?.token) return true;
        try {
            const payload = JSON.parse(atob(user.token.split('.')[1]));
            return (payload.exp * 1000) < Date.now();
        } catch {
            return true;
        }
    }
}
